"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _system = require("@mui/system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledMenuItem = (0, _system.styled)(_material.MenuItem)({
  paddingRight: 0,
  paddingLeft: "4px",
  display: "flex",
  justifyContent: "space-between"
});
var StyledTypography = (0, _system.styled)(_material.Typography)({
  paddingLeft: "8px",
  paddingRight: "8px",
  textAlign: "left"
});
var FlexBox = (0, _system.styled)(_system.Box)({
  display: "flex"
});

var IconMenuItem = function IconMenuItem(_ref) {
  var leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      onClick = _ref.onClick,
      label = _ref.label,
      MenuItemProps = _ref.MenuItemProps,
      className = _ref.className,
      ref = _ref.ref;
  return /*#__PURE__*/_react["default"].createElement(StyledMenuItem, _extends({}, MenuItemProps, {
    ref: ref,
    className: className,
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement(FlexBox, null, leftIcon, /*#__PURE__*/_react["default"].createElement(StyledTypography, null, label)), rightIcon);
};

exports.IconMenuItem = IconMenuItem;